import React from 'react';
import { styled } from '@mui/material/styles';
import { Container, Link, Typography } from '@mui/material';
import { LegalSection } from '../components/DownloadSections';


const LegalRoot = styled('div')(({ theme }) => ({
    padding: '50px 0',
}));

const LegalLink = styled(Link)(({ theme }) => ({
    marginBottom: '20px',
}));

const LinkContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}));

const Legal = () => {
    return (
        <LegalRoot>
            <Container maxWidth="lg">
                <LegalSection />
            </Container>
        </LegalRoot>
    );
};

export default Legal;
